/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration>): BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration(), model);
        BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration>): BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration.newInstance(<BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
